ui-bank-search-list {
  display: block;
  overflow: hidden;

  .bank-list {
    position: relative;
    text-align: left;
    height: 100%;
  }
}
